import request from "@/utils/http"

export const getLanguage = (timeStr) => {
  return request.get(`translate_landing/init/${timeStr}`)
}


export const languageList = () => {
  return request.get(`translate_landing`)
}

export const updateLanguage = (key, data) => {
  return request.put(`translate_landing/${key}`, data)
}

export const deleteLanguage = (key) => {
  return request.delete(`translate_landing/${key}`)
}

export const addLanguage = (key, data) => {
  return request.post(`translate_landing/${key}`, data)
}